import React from "react";
import "./contact.css";

function Contact() {
  return (
    <div className="contactContainer">
      <h1>
        Join us on email for
        <br />
        <span>more information</span>
      </h1>
      <button>join now</button>
    </div>
  );
}

export default Contact;
